export default (video) => {
  const { mpxMetadata = {} } = video;
  const mpxId = mpxMetadata.mpxId || video.mpxId || null;
  const guid = mpxMetadata.externalAdvertiserId || mpxMetadata.guid || video.guid || null;
  return {
    ...video,
    guid,
    mpxId,
  };
};
